module.exports = __webpack_public_path__ + "img/fr.42c64f28.svg";